import HandymanOutlinedIcon from "@mui/icons-material/HandymanOutlined";
import AllInboxOutlinedIcon from "@mui/icons-material/AllInboxOutlined";
import CodeOutlinedIcon from "@mui/icons-material/CodeOutlined";
import { ReactComponent as HelperTextEditIcon } from "../icons/information-edit-outline.svg";
import SystemUpdateIcon from "@mui/icons-material/SystemUpdate";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import UploadFileIcon from "@mui/icons-material/UploadFile";

import { useIntl } from "react-intl";
import { useMemo } from "react";
import { useUserInfo } from "../utils/user-info";
import SvgIcon from "@mui/icons-material/HandymanOutlined";

const useMenuLinks = () => {
  const { formatMessage } = useIntl();
  const [user] = useUserInfo();

  return useMemo(() => {
    const menuLinks = [
      {
        icon: <HandymanOutlinedIcon />,
        href: "/configuration",
        label: formatMessage({
          defaultMessage: "Devices",
        }),
      },
    ];

    if (!user?.rights?.limited_user) {
      menuLinks.push({
        icon: <UploadFileIcon />,
        href: "/configuration-import",
        label: formatMessage({
          defaultMessage: "Configuration import",
        }),
      });
    }

    if (user?.rights?.firmware_update) {
      menuLinks.push({
        icon: <SystemUpdateIcon />,
        href: "/firmware-update",
        label: formatMessage({
          defaultMessage: "Firmware update",
        }),
      });
    }

    if (user?.rights?.firmware_upload) {
      menuLinks.push({
        icon: <AllInboxOutlinedIcon />,
        href: "/firmwares",
        label: formatMessage({
          defaultMessage: "Firmwares",
        }),
      });
    }

    if (user?.rights?.remote_files) {
      menuLinks.push({
        icon: <CodeOutlinedIcon />,
        href: "/files",
        label: formatMessage({
          defaultMessage: "Files",
        }),
      });
    }

    if (user?.rights?.template_helper) {
      menuLinks.push({
        icon: <SvgIcon component={HelperTextEditIcon} />,
        href: "/template-helpers",
        label: formatMessage({
          defaultMessage: "Configuration helpers",
        }),
      });
    }

    if (user?.rights?.user_admin) {
      menuLinks.push({
        icon: <PeopleAltOutlinedIcon />,
        href: "/users",
        label: formatMessage({
          defaultMessage: "Users",
        }),
      });
    }

    return menuLinks;
  }, [formatMessage, user]);
};

export default useMenuLinks;

export enum ToolboxRoutes {
  Configuration = "/configuration",
}
